import ReactOnRails from 'react-on-rails';
import SeoCitySingle from '../../bundles/SeoCitySingle/components/SeoCitySingle.client.jsx';

ReactOnRails.register({SeoCitySingle});
